import type { JSX } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Icon } from '@/components/ui/icon';
import { Heading2 } from '@/components/blocks/typography';

interface DatabaseErrorStateProps {
  error: Error;
}

/**
 * Full-screen error state shown when the database fails to initialize.
 * Offers a reload button to retry.
 */
export function DatabaseErrorState({ error }: DatabaseErrorStateProps): JSX.Element {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface p-4">
      <Card className="w-full max-w-md overflow-hidden border border-[var(--border-default)] bg-surface shadow-md">
        <div className="h-1 w-full bg-danger-500" />
        <div className="flex flex-col gap-4 p-6">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-danger-100 text-danger-500">
            <Icon name="error" className="text-2xl" />
          </div>
          <div className="space-y-2">
            <Heading2 className="text-xl font-semibold text-text-primary">
              Errore di inizializzazione
            </Heading2>
            <p className="text-sm text-text-secondary">
              Impossibile inizializzare il database locale. Questo potrebbe essere causato da
              storage insufficiente o da un problema del browser.
            </p>
            <p className="rounded bg-neutral-100 p-2 font-mono text-xs text-text-secondary">
              {error.message}
            </p>
          </div>
          <Button onClick={handleReload} className="w-full">
            <Icon name="refresh" className="mr-2" />
            Riprova
          </Button>
        </div>
      </Card>
    </div>
  );
}
